import { X } from "lucide-react";
import { useFormattedDate } from "../../hooks/useFormattedDate";

const Trail = ({ closeAuditTrail, auditData }) => {
  const formatDate = useFormattedDate();
  const {
    method,
    route,
    statusCode,
    ip,
    userAgent,
    createdAt,
    responseTimeMs,
    query,
    userId,
  } = auditData;

  function deriveActionDescription(method, route) {
    // Clean the route and extract meaningful parts
    const cleanRoute = route.replace(/^\/api\/v\d+\//, "").replace(/-/g, " ");
    const parts = cleanRoute.split("/").filter(Boolean); // Split into parts

    // Join meaningful parts into a phrase
    const resource = parts.join(" ");

    // Map HTTP method to an action verb
    const methodActionMap = {
      GET: "View",
      POST: "Create",
      PUT: "Update",
      PATCH: "Modify",
      DELETE: "Delete",
    };

    const actionVerb = methodActionMap[method.toUpperCase()] || method;

    // Return the final description
    return `${actionVerb} ${resource}`;
  }

  function deriveModuleFromRoute(route) {
    // Remove '/api/' prefix and optional version like 'v1/', 'v2/', etc.
    const cleanRoute = route.replace(/^\/api\/(v\d+\/)?/, "");

    // Split by '/' and take the first part
    const [firstSegment] = cleanRoute.split("/").filter(Boolean);

    // Replace dashes with spaces and return as module name
    return firstSegment ? firstSegment.replace(/-/g, " ") : "unknown";
  }

  const action = deriveActionDescription(method, route);
  const module = deriveModuleFromRoute(route);

  return (
    <div
      onClick={closeAuditTrail}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[550px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto shadow-lg"
      >
        {/* Close Button */}
        <div
          onClick={closeAuditTrail}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>

        {/* Title */}
        <p className="font-bold text-center text-[#000000] text-[18px] mb-[20px]">
          Audit Trail Details
        </p>
        {/* Audit Details */}
        <div className="grid grid-cols-3 gap-4 text-sm text-gray-800">
          <div>
            <p className="font-semibold">Action</p>
            <p>{action}</p>
          </div>
          <div>
            <p className="font-semibold">User</p>
            <p>{userId}</p>
          </div>
          <div>
            <p className="font-semibold">Module</p>
            <p>{module}</p>
          </div>
          <div>
            <p className="font-semibold">HTTP Method</p>
            <p>{method}</p>
          </div>
          <div>
            <p className="font-semibold">Status Code</p>
            <p>{statusCode}</p>
          </div>
          <div>
            <p className="font-semibold">Response Time</p>
            <p>{responseTimeMs} ms</p>
          </div>
          <div>
            <p className="font-semibold">Timestamp</p>
            <p>{formatDate(createdAt)}</p>
          </div>
          <div>
            <p className="font-semibold">IP Address</p>
            <p>{ip}</p>
          </div>
          <div className="col-span-2 mt-4">
            <p className="font-semibold">Endpoint</p>
            <p className="break-all">{route}</p>
          </div>
        </div>
        <div className="my-[10px]">
          <p className="font-semibold">User Agent</p>
          <p className="">{userAgent}</p>
        </div>
        {Object.keys(query).length > 0 && (
          <div className="col-span-2 mt-2">
            <p className="font-semibold">Query Params</p>
            <pre className="bg-gray-100 p-2 rounded text-sm">
              {JSON.stringify(query, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default Trail;
